import React from 'react';

import TeamMapHeader from './TeamMapHeader';
import TeamMapFooter from './TeamMapFooter';
import PersonRow from './PersonRow';

const AllMembersList = ({ label, members, endText, t = {}, lang }) => {
	const title = t.title || 'Team Map';
	const colGenius = t.colGenius || 'Working Genius';
	const colCompetency = t.colCompetency || 'Working Competency';
	const colFrustration = t.colFrustration || 'Working Frustration';

	return (
		<section role='region' className='Page'>
			<TeamMapHeader />
			<div className='Page__content'>
				<div className='Page__callout'>
					<h1>{title}</h1>
					<h2 className='lightblack'>{label}</h2>
				</div>
				<table className='AllMembersList'>
					<thead className='AllMembersList__thead bold'>
						<tr>
							<th scope='col' />
							<th scope='col'>{colGenius}</th>
							<th scope='col'>{colCompetency}</th>
							<th scope='col'>{colFrustration}</th>
						</tr>
					</thead>
					<tbody>
						{members.map((member, idx) => (
							<PersonRow member={member} key={idx} lang={lang} />
						))}
						<tr>
							<td colSpan={4} className={'text-center'} style={{ paddingTop: '20px' }}>
								{endText}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<TeamMapFooter />
		</section>
	);
};

export default AllMembersList;
